import React from 'react';
import RecordsProgressive from './records-progressive';

export default function RechargeRecordsProgressive() {
  return <RecordsProgressive type="recharge" />;
}
